var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ViewKanban',{attrs:{"id_tabla":23,"id_enumeracion":6,"nombre_variable":'id_estado'}})}
var staticRenderFns = []

export { render, staticRenderFns }